import makeStyles from '@mui/styles/makeStyles';

const ROOT_PADDING = 20;
const MODULE_BOX_ICON_DIMENSION = 70;
const MODULE_BOX_ROOT_DIMENSION = 200;

const getRootDimension = (size) => {
    switch (size) {
        default:
        case 'large':
            return MODULE_BOX_ROOT_DIMENSION;
        case 'medium':
            return 0.7 * MODULE_BOX_ROOT_DIMENSION;
        case 'small':
            return 0.5 * MODULE_BOX_ROOT_DIMENSION;
    }
};

const getCornerIconOffset = (size) => {
    const baseOffset = 24;
    switch (size) {
        default:
        case 'large':
            return baseOffset;
        case 'medium':
            return 0.7 * baseOffset;
        case 'small':
            return 0.5 * baseOffset;
    }
};

const getIconDimension = (size) => {
    switch (size) {
        default:
        case 'large':
            return MODULE_BOX_ICON_DIMENSION;
        case 'medium':
            return 0.7 * MODULE_BOX_ICON_DIMENSION;
        case 'small':
            return 0.5 * MODULE_BOX_ICON_DIMENSION;
    }
};

const getModuleDescriptionFontSize = (size) => {
    switch (size) {
        default:
        case 'large':
            return 16;
        case 'small':
        case 'medium':
            return 0.7 * 16;
    }
};

export const useCentralPageStyles = makeStyles((theme) => ({
    centralPageRoot: {
        paddingRight: 0,
        flexWrap: 'nowrap',
        padding: ROOT_PADDING,
    },
    menuRoot: {
        padding: 40,
        display: 'flex',
        width: '100%',
        minWidth: 250,
        borderRadius: 40,
        alignItems: 'center',
        flexDirection: 'column',
        height: `calc(100vh - ${2 * ROOT_PADDING}px)`,
        backgroundColor: theme.palette.background.paperDarker,
    },
    centralPageContentRoot: {
        flexGrow: 1,
        paddingRight: 14,
        flexDirection: 'row',
        alignContent: 'flex-start',
        height: `calc(100vh - ${2 * ROOT_PADDING}px)`,
        minWidth: MODULE_BOX_ROOT_DIMENSION + 175,
    },
    userInitials: {
        color: theme.palette.primary.main,
    },
    editButton: {
        width: 80,
        minWidth: 80,
        marginTop: 16,
    },
    contextButton: {
        width: '100%',
        paddingLeft: 16,
        minWidth: '100%',
        justifyContent: 'flex-start',
        color: theme.palette.primary.main,

        '&:hover, &.active': {
            color: '#FFF',
            backgroundColor: theme.palette.primary.main,
        },
    },
    upgradeButton: {
        width: '100%',
        minWidth: '100%',
        background: 'linear-gradient(to left, #923DFF, #0047FF)',
    },
    menuBottomButtons: {
        gap: 30,
        display: 'flex',
        width: '100%',
        marginTop: 30,
        minWidth: '100%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    centralPageContextTitle: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
    },
    titleAddons: {
        gap: 10,
        display: 'flex',
        marginLeft: 20,
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'nowrap',
    },
    addonBox: {
        height: 40,
        minWidth: 40,
        display: 'flex',
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.background.paperDarker,

        '&.agyleColor svg': {
            color: theme.palette.primary.main,
        },
        '&.cursorPointer': {
            cursor: 'pointer',
        },
    },
    moduleItem: {
        display: 'flex',
        borderRadius: 10,
    },
    moduleBoxRoot: ({ size, paperBackground }) => ({
        display: 'flex',
        borderRadius: 20,
        cursor: 'pointer',
        overflow: 'hidden',
        alignItems: 'center',
        position: 'relative',
        flexDirection: 'column',
        // gap: size !== 'small' && 10,
        gap: size !== 'small' ? 15 : 5,
        padding: size === 'small' ? 8 : 20,
        // paddingBottom: size !== 'small' && 20,
        paddingBottom: size === 'small' ? 8 : 20,
        // justifyContent: 'space-between',
        justifyContent: 'center',
        width: getRootDimension(size),
        height: getRootDimension(size),
        minWidth: getRootDimension(size),
        minHeight: getRootDimension(size),
        border: `1px solid ${theme.palette.mode === 'light' ? '#808284FF' : 'transparent'}`,
        backgroundColor: paperBackground ? theme.palette.background.paper : theme.palette.background.paperDarker,

        '&:hover': {
            borderColor: theme.palette.primary.main,
        },
        '&.upgradeModule': {
            borderRadius: 10,
            backgroundColor: theme.palette.background.paperDarker,
            border: `1px solid ${theme.palette.mode === 'light' ? '#808284FF' : 'transparent'}`,
        },
        '&.disabledRedirect, &.currentLocation': {
            pointerEvents: 'none',
        },
        '&.currentLocation': {
            borderColor: theme.palette.primary.main,
        },
    }),
    moduleBoxIcon: ({ size }) => ({
        marginTop: 10,
        width: getIconDimension(size),
        height: getIconDimension(size),
        minWidth: getIconDimension(size),
        minHeight: getIconDimension(size),
        color: theme.palette.mode === 'light' ? '#808284FF' : '#FFF',

        '& svg': {
            width: getIconDimension(size),
            height: getIconDimension(size),
            minWidth: getIconDimension(size),
            minHeight: getIconDimension(size),
        },
    }),

    moduleCornerIcon: ({ size }) => {
        const offset = getCornerIconOffset(size);
        const dimension = getIconDimension(size) * 0.5;
        return {
            position: 'absolute',
            top: offset,
            right: offset,
            width: dimension,
            height: dimension,
            minWidth: dimension,
            minHeight: dimension,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.palette.mode === 'light' ? '#808284FF' : '#FFF',
            zIndex: 2,

            '& svg': {
                width: '100%',
                height: '100%',
            },
        };
    },

    // moduleBoxDescription: ({ size }) => ({
    //     // paddingLeft: size !== 'large' && 5,
    //     // paddingRight: size !== 'large' && 5,
    //     // paddingBottom: size !== 'large' && 3,
    //     fontSize: getModuleDescriptionFontSize(size),
    //     color: theme.palette.mode === 'light' ? '#808284FF' : '#FFF',
    // }),

    moduleBoxDescription: ({ size, groupColor }) => ({
        fontSize: getModuleDescriptionFontSize(size),
        color: groupColor ?? (theme.palette.mode === 'light' ? '#808284FF' : '#FFF'),
        fontWeight: 700,
        textAlign: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        lineHeight: 1.2,
        maxWidth: '100%',
    }),

    moduleToUpgradeContainer: {
        alignItems: 'flex-end',
    },
    upgradeModuleInfo: {
        margin: 10,
        flexGrow: 1,
        padding: 10,
        display: 'flex',
        marginBottom: 0,
        paddingBottom: 0,
        alignItems: 'flex-end',
        justifyContent: 'space-between',
    },
    priceTag: {
        gap: 10,
        display: 'flex',
        alignItems: 'center',
    },
    settlementsButton: {
        color: theme.palette.primary.main,

        '&:hover': {
            color: '#FFF',
            background: theme.palette.primary.main,
        },
    },
    avatar: {
        borderRadius: '50%',
        border: `2px solid ${theme.palette.primary.main}`,
    },
    specChip: {
        borderRadius: 20,
        padding: '6px 10px',
        backgroundColor: theme.palette.background.paper,
    },
    announcementsIndicator: {
        position: 'relative',
    },
    announcementsIndicatorCount: {
        right: -8,
        width: 22,
        height: 22,
        bottom: -8,
        color: '#FFF',
        display: 'flex',
        paddingTop: 1,
        paddingLeft: -2,
        position: 'absolute',
        alignItems: 'center',
        borderRadius: '50%',
        justifyContent: 'center',
        backgroundColor: theme.palette.error.dark,
    },

    sortMenuPaper: {
        marginTop: 8,
        minWidth: 190,
        backgroundColor: theme.palette.background.paperDarker,
        // color: theme.palette.mode === 'light' ? '#808284FF' : '#FFF',
        border: `1px solid ${theme.palette.mode === 'light' ? '#80828488' : '#80828444'}`,
        borderRadius: 8,
        boxShadow: '0 10px 24px rgba(0,0,0,0.35)',
        overflow: 'hidden',
    },
    sortMenuList: {
        padding: 4,
    },
    sortMenuDivider: {
        marginTop: 4,
        marginBottom: 4,
        borderColor: theme.palette.mode === 'light' ? '#80828488' : '#80828444',
    },
    sortMenuItem: {
        minHeight: 38,
        padding: '6px 10px',
        borderRadius: 6,
        // color: theme.palette.mode === 'light' ? theme.palette.primary.main : '#FFF',
        '&:hover': {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.04)',
        },
    },
    sortMenuItemIcon: {
        minWidth: '22px !important',
        color: theme.palette.text.primary,
    },
    sortMenuItemText: {
        fontSize: '14px !important',
        fontWeight: '500 !important',
    },
    sortMenuCheckIcon: {
        fontSize: '18px !important',
        color: '#2f80ed',
        marginLeft: 8,
    },
}));
